/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
    .controller('ShopAllowancesOrChargesController', function ($scope, $q, $element, ControlService, CommonUtils, Validation) {
        $scope.Model = $scope.Model || {};
        $scope.Control = $scope.Control || {};
        $scope.Control.Loading = false;
        var controlName = 'ShopAllowancesOrCharges';
        $scope.registerControl(controlName, $element.get(0));

        $scope.Control.SelectedOrderTypeId = undefined;

        var setAllowancesOrChargeActive = function (allowancesOrCharge) {
            var deferred = $q.defer();

  
            ControlService.invokeCheckout($scope, $element, 'SetShopAllowancesOrCharge', allowancesOrCharge).then(function (setResponse) {

                if ($scope['Order'] && $scope['Order'].Wrapper && typeof ($scope['Order'].Wrapper.reload) == 'function') {
                    $scope['Order'].Wrapper.reload().then(function (bmresponse) {
                        deferred.resolve(true);
                        $scope.Control.Loading = false;
                    }, function (bmerror) {
                        deferred.reject(bmerror);
                        $scope.Control.Loading = false;
                    });
                } else {
                    deferred.resolve();
                    $scope.Control.Loading = false;
                }
            }, function (error) {
                deferred.reject(error);
                $scope.Control.Loading = false;
            });

            return deferred.promise;
        };

        $scope.Control.IsAllowanceOrChargeApplied = function (allowancesOrChargeCode) {

            var shopAllowancesOrCharge = _.first(_.filter($scope['Order'].Current.ShopAllowancesOrCharges, function (x) { return x.Code === allowancesOrChargeCode; }));

            if (typeof shopAllowancesOrCharge != 'undefined')
                return shopAllowancesOrCharge.IsAppliedOnOrder;
            else
                return false;

        };

        var removeAllowancesOrChargeActive = function (allowancesOrCharge) {
            var deferred = $q.defer();


            ControlService.invokeCheckout($scope, $element, 'RemoveShopAllowancesOrCharge', allowancesOrCharge).then(function (setResponse) {

                if ($scope['Order'] && $scope['Order'].Wrapper && typeof ($scope['Order'].Wrapper.reload) == 'function') {
                    $scope['Order'].Wrapper.reload().then(function (bmresponse) {
                        deferred.resolve(true);
                        $scope.Control.Loading = false;
                    }, function (bmerror) {
                        deferred.reject(bmerror);
                        $scope.Control.Loading = false;
                    });
                } else {
                    deferred.resolve();
                    $scope.Control.Loading = false;
                }
            }, function (error) {
                deferred.reject(error);
                $scope.Control.Loading = false;
            });

            return deferred.promise;
        };



        $scope.Control.setorResetSelectedAllowancesOrCharge = function (code) {


            var shopAllowancesOrCharge = _.first(_.filter($scope['Order'].Current.ShopAllowancesOrCharges, function (x) { return x.Code === code; }));
         
            if (shopAllowancesOrCharge.IsAppliedOnOrder) {
                removeAllowancesOrChargeActive(shopAllowancesOrCharge).then(function (parameters) {
                    $scope.Control.Loading = false;
                }, function (error) {
                    $scope.Control.Loading = false;
                });
            } else {

                shopAllowancesOrCharge = _.first(_.filter($scope.Model.Data.ShopAllowancesOrCharges, function (x) { return x.Code === code; }));

                setAllowancesOrChargeActive(shopAllowancesOrCharge).then(function (parameters) {
                    $scope.Control.Loading = false;
                }, function(error) {
                    $scope.Control.Loading = false;
                });
            }
        };

        ControlService.getCheckoutData("GetShopAllowancesOrChargesData", $scope, $element).then(function (response) {
         
            $scope.Model = {};
            angular.extend($scope.Model, response);
            $scope.Control.Loading = false;
        }, function (error) {
            $scope.Control.Loading = false;
            throw error;
        });

        $element.get(0).reload = function () {
            var deferred = $q.defer();
            ControlService.getCheckoutData("GetShopAllowancesOrChargesData", $scope, $element).then(function (response) {
                setTimeout(function () {
                    $('.x-checkoutshippingaddress .form-row.postcode').removeClass('x-loading');
                    $('.x-checkoutshippingaddress .form-row.area').removeClass('x-loading');
                    $('.x-checkoutbillingaddress .form-row.postcode').removeClass('x-loading');
                    $('.x-checkoutbillingaddress .form-row.area').removeClass('x-loading');
                }, 300);

                $scope.Model = {};
                angular.extend($scope.Model, response);
                $scope.Control.Loading = false;
            }, function (error) {
                $scope.Control.Loading = false;
                throw error;
            });
            return deferred.promise;
        };

        $scope.Control.HasActiveAllowancesOrCharges = function () {

            if ($scope.Model.Data!=undefined&&$scope.Model.Data.ShopAllowancesOrCharges.length > 0) {
                return true;
            }

            return false;
        };
    });
})();